{
  "check-details": "Check details →",
  "no-result-found": "No products found in this category.",
  "technical-characteristics": "Technical characteristics"
}
